import { makeStyles } from 'tss-react/mui';

export default makeStyles()({
    letters: {
        marginBottom: 24
    }
});
